export const endpoints = {
  details: '/report/serviceOrderDetails',
  form: '/report/serviceOrderForm',
}
